<template>

    <v-modal title="Delay">

        <template #body>
            <v-alert :message="error" />
            <v-form-group dir="ver" label="Wait for">
                <v-delay-picker :model="params.delay" @input="params.delay = $event" />
            </v-form-group>
            <v-form-group dir="ver">
                <v-checkbox label="Resume at..." :model="params.resume_enabled" @input="params.resume_enabled = $event" />
            </v-form-group>
            <v-form-group v-if="params.resume_enabled" dir="ver">
                <div class="d-flex">
                    <v-time-picker :model="params.resume_time" @input="params.resume_time = $event" />
                    <v-timezone-picker class="ml-5 flex-grow-1" label="Customer’s Timezone" :model="params.resume_timezone" @input="params.resume_timezone = $event" />
                </div>
            </v-form-group>
            <v-form-group v-if="params.resume_enabled" dir="ver" label="Only resume on">
                <v-days-picker :model="params.resume_days" @input="params.resume_days = $event" />
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="saveAction">Save</v-button>
        </template>

    </v-modal>

</template>

<script>

import ModalActionMixin from '@mixins/ModalActionMixin';

export default {

    mixins: [ModalActionMixin],

    data() {
        return {
            params: {
                type: this.action.type,
                delay: this.action.delay,
                resume_enabled: this.action.resume_enabled,
                resume_time: this.action.resume_time,
                resume_timezone: this.action.resume_timezone,
                resume_days: this.action.resume_days,
            },
        }
    },

    methods: {

        updateTime(e) {
            this.params.resume_time = e.time;
            this.params.resume_timezone = e.timezone;
        },

    },

}

</script>
